export default __webpack_public_path__ + "static/media/onboardingLogo.13cf8c5c.png";